/* Signamic — Apple-style configurator: state, pricing, summary, cart + checkout. */
(function () {
  'use strict';

  function init(root) {
    if (root.__sgcInit) return;
    root.__sgcInit = true;

    var cfgEl = root.querySelector('[data-sgc-config]');
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[sgc] bad config', e); return; }

    var cur = CFG.currency || '$';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    function money(n) { return cur + (Number(n) || 0).toFixed(2); }
    function lowestPrice(prices) {
      var valid = prices.map(Number).filter(function (price) { return isFinite(price) && price > 0; });
      return valid.length ? Math.min.apply(Math, valid) : 0;
    }
    function fromPrice(price, recurring) {
      return price ? ('From ' + money(price) + (recurring ? '<small>/mo</small>' : '')) : '';
    }
    function sizeById(id) { return CFG.sizes.filter(function (s) { return s.id === id; })[0] || null; }
    function addonById(id) { return CFG.addons.filter(function (a) { return a.id === id; })[0] || null; }

    var state = {
      size: null,
      plan: null,
      addons: [],
      quantity: 1
    };

    /* ---- single-plan mode: locked plan, or no Buy/Subscribe group, sells each size one way ---- */
    var lockedPlan = root.getAttribute('data-sgc-locked-plan');
    if (lockedPlan !== 'purchase' && lockedPlan !== 'subscribe') lockedPlan = '';
    var singlePlan = !!lockedPlan || $$('[data-sgc-plan]').length === 0;
    if (singlePlan) state.plan = lockedPlan || 'subscribe';
    if (lockedPlan === 'purchase' && CFG.sizes.length) {
      var standardSize = null;
      for (var si = 0; si < CFG.sizes.length; si++) {
        var sizeName = String(CFG.sizes[si].name || '').toLowerCase();
        var sizeValue = String(CFG.sizes[si].value || '').toLowerCase();
        if (sizeName === 'standard' || sizeValue === 'standard') { standardSize = CFG.sizes[si]; break; }
      }
      if (standardSize) state.size = standardSize.id;
    }

    /* ---- product-image gallery ---- */
    var gallery = $('[data-sgc-gallery]');
    var galleryTrack = $('[data-sgc-gallery-track]');
    var gallerySlides = $$('[data-sgc-gallery-slide]');
    var galleryDots = $$('[data-sgc-gallery-dot]');
    var galleryIndex = 0;
    var galleryTimer = null;
    var galleryHovered = false;
    function showGallerySlide(index) {
      if (!galleryTrack || gallerySlides.length < 2) return;
      galleryIndex = (index + gallerySlides.length) % gallerySlides.length;
      galleryTrack.style.transform = 'translateX(-' + (galleryIndex * 100) + '%)';
      gallerySlides.forEach(function (slide, i) { slide.setAttribute('aria-hidden', i === galleryIndex ? 'false' : 'true'); });
      galleryDots.forEach(function (dot, i) {
        var active = i === galleryIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
    function syncGalleryAutoplay() {
      if (galleryTimer) { window.clearInterval(galleryTimer); galleryTimer = null; }
      var noChoicesSelected = !state.size && (!state.plan || lockedPlan) && state.addons.length === 0;
      if (gallerySlides.length > 1 && noChoicesSelected && !galleryHovered) {
        galleryTimer = window.setInterval(function () { showGallerySlide(galleryIndex + 1); }, 4500);
      }
    }
    var previousImage = $('[data-sgc-gallery-prev]'), nextImage = $('[data-sgc-gallery-next]');
    if (previousImage) previousImage.addEventListener('click', function () { showGallerySlide(galleryIndex - 1); });
    if (nextImage) nextImage.addEventListener('click', function () { showGallerySlide(galleryIndex + 1); });
    galleryDots.forEach(function (dot) {
      dot.addEventListener('click', function () { showGallerySlide(parseInt(dot.getAttribute('data-sgc-gallery-dot'), 10)); });
    });
    if (gallery && gallerySlides.length > 1) {
      gallery.setAttribute('tabindex', '0');
      gallery.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showGallerySlide(galleryIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showGallerySlide(galleryIndex + 1); }
      });
      var swipeStartX = null;
      gallery.addEventListener('pointerdown', function (event) { swipeStartX = event.clientX; });
      gallery.addEventListener('pointerup', function (event) {
        if (swipeStartX === null) return;
        var distance = event.clientX - swipeStartX;
        swipeStartX = null;
        if (Math.abs(distance) > 40) showGallerySlide(galleryIndex + (distance < 0 ? 1 : -1));
      });
      gallery.addEventListener('pointerenter', function () { galleryHovered = true; syncGalleryAutoplay(); });
      gallery.addEventListener('pointerleave', function () { galleryHovered = false; syncGalleryAutoplay(); });
    }

    /* ---- selected size media / caption ---- */
    var mediaCap = $('[data-sgc-media-caption]');
    function paintMedia() {
      var sz = sizeById(state.size);
      if (sz && gallerySlides.length) {
        var requestedSlide = Math.max(1, Number(sz.carouselSlide) || 1);
        showGallerySlide(Math.min(requestedSlide, gallerySlides.length) - 1);
      }
      if (mediaCap) mediaCap.textContent = sz ? (sz.name + (sz.dim ? ' — ' + sz.dim : '')) : 'Select your configuration';
    }

    /* ---- size ---- */
    var sizePricingEl = $('[data-sgc-size-pricing]');
    function lowestPriceFormattedFor(key, formattedKey) {
      var lowest = Infinity, formatted = null;
      CFG.sizes.forEach(function (sz) {
        var val = Number(sz[key]);
        if (isFinite(val) && val > 0 && val < lowest) { lowest = val; formatted = sz[formattedKey] || null; }
      });
      if (lowest === Infinity) return null;
      return formatted || money(lowest);
    }
    function paintSizeOptionPrices() {
      var purchaseLabel = (CFG.planLabels && CFG.planLabels.purchase) || 'Buy';
      var subscribeLabel = (CFG.planLabels && CFG.planLabels.subscribe) || 'Subscribe';
      CFG.sizes.forEach(function (sz) {
        var el = $('[data-sgc-size-price-line="' + sz.id + '"]');
        if (!el) return;
        var subscribeAmt = sz.priceSubscribeFormatted || money(sz.priceSubscribe);
        if (singlePlan && state.plan === 'purchase') {
          el.textContent = sz.pricePurchaseFormatted || money(sz.pricePurchase);
          return;
        }
        if (singlePlan) {
          el.textContent = subscribeAmt + '/mo';
          return;
        }
        var purchaseAmt = sz.pricePurchaseFormatted || money(sz.pricePurchase);
        el.textContent = purchaseLabel + ' ' + purchaseAmt + ' or ' + subscribeLabel.toLowerCase() + ' ' + subscribeAmt;
      });
    }
    function paintSize() {
      $$('[data-sgc-size]').forEach(function (b) {
        b.classList.toggle('selected', b.getAttribute('data-sgc-size') === state.size);
      });
      if (sizePricingEl) {
        var sz = sizeById(state.size);
        if (sz) {
          var subscribeAmt = sz.priceSubscribeFormatted || money(sz.priceSubscribe);
          if (singlePlan && state.plan === 'purchase') {
            sizePricingEl.innerHTML = sz.pricePurchaseFormatted || money(sz.pricePurchase);
            sizePricingEl.hidden = false;
            return;
          }
          if (singlePlan) {
            sizePricingEl.innerHTML = subscribeAmt + '<small>/mo</small>';
            sizePricingEl.hidden = false;
            return;
          }
          var purchaseLabel = (CFG.planLabels && CFG.planLabels.purchase) || 'Buy';
          var subscribeLabel = (CFG.planLabels && CFG.planLabels.subscribe) || 'Subscribe';
          var purchaseAmt = sz.pricePurchaseFormatted || money(sz.pricePurchase);
          sizePricingEl.innerHTML = purchaseLabel + ' ' + purchaseAmt + ' or ' + subscribeLabel.toLowerCase() + ' ' + subscribeAmt + '<small>/mo</small>';
          sizePricingEl.hidden = false;
        } else if (singlePlan && state.plan === 'purchase') {
          var lfPurchaseOnly = lowestPriceFormattedFor('pricePurchase', 'pricePurchaseFormatted');
          if (lfPurchaseOnly) {
            sizePricingEl.innerHTML = 'From ' + lfPurchaseOnly;
            sizePricingEl.hidden = false;
          } else {
            sizePricingEl.innerHTML = '';
            sizePricingEl.hidden = true;
          }
        } else if (singlePlan) {
          var lfSubscribeOnly = lowestPriceFormattedFor('priceSubscribe', 'priceSubscribeFormatted');
          if (lfSubscribeOnly) {
            sizePricingEl.innerHTML = 'From ' + lfSubscribeOnly + '<small>/mo</small>';
            sizePricingEl.hidden = false;
          } else {
            sizePricingEl.innerHTML = '';
            sizePricingEl.hidden = true;
          }
        } else {
          var purchaseLabel2 = (CFG.planLabels && CFG.planLabels.purchase) || 'Buy';
          var subscribeLabel2 = (CFG.planLabels && CFG.planLabels.subscribe) || 'Subscribe';
          var lfPurchase = lowestPriceFormattedFor('pricePurchase', 'pricePurchaseFormatted');
          var lfSubscribe = lowestPriceFormattedFor('priceSubscribe', 'priceSubscribeFormatted');
          if (lfPurchase || lfSubscribe) {
            var parts = [];
            if (lfPurchase) parts.push(purchaseLabel2 + ' from ' + lfPurchase);
            if (lfSubscribe) parts.push(subscribeLabel2.toLowerCase() + ' from ' + lfSubscribe);
            sizePricingEl.innerHTML = parts.join(' or ');
            sizePricingEl.hidden = false;
          } else {
            sizePricingEl.innerHTML = '';
            sizePricingEl.hidden = true;
          }
        }
      }
    }
    $$('[data-sgc-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-sgc-size');
        state.size = state.size === id ? null : id;
        paintSize(); paintPlan(); paintMedia(); render();
      });
    });

    /* ---- plan ---- */
    function paintPlan() {
      $$('[data-sgc-plan]').forEach(function (b) {
        b.classList.toggle('selected', b.getAttribute('data-sgc-plan') === state.plan);
      });
      var sz = sizeById(state.size);
      var subEl = $('[data-sgc-plan-price="subscribe"]'), buyEl = $('[data-sgc-plan-price="purchase"]');
      var lowestSubscribe = lowestPrice(CFG.sizes.map(function (size) { return size.priceSubscribe; }));
      var lowestPurchase = lowestPrice(CFG.sizes.map(function (size) { return size.pricePurchase; }));
      if (subEl) subEl.innerHTML = sz ? ((sz.priceSubscribeFormatted || money(sz.priceSubscribe)) + '<small>/mo</small>') : fromPrice(lowestSubscribe, true);
      if (buyEl) buyEl.innerHTML = sz ? (sz.pricePurchaseFormatted || money(sz.pricePurchase)) : fromPrice(lowestPurchase, false);
    }
    $$('[data-sgc-plan]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (lockedPlan) return;
        var plan = b.getAttribute('data-sgc-plan');
        state.plan = state.plan === plan ? null : plan;
        paintPlan(); paintSize(); render();
      });
    });

    /* ---- add-ons (multi-select) ---- */
    function paintAddons() {
      $$('[data-sgc-addon]').forEach(function (b) {
        b.classList.toggle('selected', state.addons.indexOf(b.getAttribute('data-sgc-addon')) !== -1);
      });
    }
    $$('[data-sgc-addon]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-sgc-addon'), i = state.addons.indexOf(id);
        if (i === -1) state.addons.push(id); else state.addons.splice(i, 1);
        paintAddons(); render();
      });
    });

    /* ---- quantity ---- */
    var qtyDisp = $('[data-sgc-qty-display]');
    $$('[data-sgc-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.quantity = Math.max(1, state.quantity + parseInt(b.getAttribute('data-sgc-qty'), 10));
        if (qtyDisp) qtyDisp.textContent = state.quantity;
        render();
      });
    });

    /* ---- pricing + summary ---- */
    function totals() {
      var qty = state.quantity, sz = sizeById(state.size);
      var today = 0, recurring = 0;
      if (sz) {
        if (state.plan === 'purchase') today += sz.pricePurchase;
        else if (state.plan === 'subscribe') {
          recurring += sz.priceSubscribe;
          today += sz.priceSubscribe + (CFG.setupFee || 0);
        }
      }
      state.addons.forEach(function (id) {
        var a = addonById(id);
        if (!a) return;
        if (a.recurring) recurring += a.price; else today += a.price;
      });
      return { today: today * qty, recurring: recurring * qty };
    }
    function syncActions() {
      var ready = !singlePlan || !!state.size;
      $$('[data-sgc-add], [data-sgc-checkout]').forEach(function (b) {
        if (b.classList.contains('is-loading')) return;
        b.disabled = !ready;
      });
    }
    function render() {
      var sz = sizeById(state.size), t = totals();
      var complete = !!(sz && state.plan);
      syncGalleryAutoplay();
      syncActions();
      $$('[data-sgc-bar-total]').forEach(function (el) {
        el.textContent = complete ? money(t.today) : '—';
      });
    }

    /* ---- cart line items ---- */
    function buildItems() {
      var qty = state.quantity, items = [], sz = sizeById(state.size), missing = false;
      if (!sz || !state.plan) {
        missing = true;
      } else {
        var v = state.plan === 'purchase' ? sz.variantPurchase : sz.variantSubscribe;
        if (v && Number(v) > 0) {
          var item = { id: Number(v), quantity: qty };
          if (state.plan !== 'purchase' && sz.sellingPlan && Number(sz.sellingPlan) > 0) {
            item.selling_plan = Number(sz.sellingPlan);
          }
          items.push(item);
        }
        else missing = true;
      }
      if (state.plan === 'subscribe' && CFG.setupFee > 0) {
        if (Number(CFG.setupVariant) > 0) items.push({ id: Number(CFG.setupVariant), quantity: qty });
        else missing = true;
      }
      state.addons.forEach(function (id) {
        var a = addonById(id);
        if (a && Number(a.variant) > 0) items.push({ id: Number(a.variant), quantity: qty });
      });
      return { items: items, missing: missing };
    }
    function configurationError() {
      if (!state.size) return singlePlan ? 'Select a size first.' : 'Select a size and payment plan first.';
      if (!state.plan) return 'Select a payment plan first.';
      if (singlePlan && state.plan === 'purchase') return 'This size is not available to buy outright.';
      return 'Map your Shopify variant IDs in the theme editor first.';
    }

    /* ---- cart drawer helpers ---- */
    function drawer() { return document.querySelector('cart-drawer'); }
    function sectionsToRender() {
      var d = drawer();
      if (d && typeof d.getSectionsToRender === 'function') return d.getSectionsToRender().map(function (x) { return x.id; });
      return ['cart-drawer', 'cart-icon-bubble'];
    }
    function openDrawer(sections) {
      var d = drawer();
      if (d && typeof d.renderContents === 'function') {
        d.classList.remove('is-empty');
        try { d.renderContents({ sections: sections, id: 'sgc-add' }); } catch (e) {}
      }
    }
    function updateCartIcon(sections) {
      var html = sections && sections['cart-icon-bubble'];
      var target = document.getElementById('cart-icon-bubble');
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var replacement = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section');
      if (replacement) target.innerHTML = replacement.innerHTML;
    }

    var msg = $('[data-sgc-msg]');
    function setMsg(text, isError) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('is-error', !!isError);
    }

    function post(url, body) {
      /* Send as multipart form data (like Shopify's native product-form) rather than a raw JSON
         fetch body — some installed apps intercept /cart/add(.js) fetches and mangle JSON payloads
         (e.g. dropping selling_plan) but respect real form-style submissions. */
      var formData = new FormData();
      (body.items || []).forEach(function (item, i) {
        formData.append('items[' + i + '][id]', item.id);
        formData.append('items[' + i + '][quantity]', item.quantity);
        if (item.selling_plan) formData.append('items[' + i + '][selling_plan]', item.selling_plan);
      });
      if (body.sections) formData.append('sections', body.sections.join(','));
      if (body.sections_url) formData.append('sections_url', body.sections_url);
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      }).then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); });
    }

    function withLoading(btns, fn) {
      btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
      return fn().finally(function () {
        btns.forEach(function (b) { b.classList.remove('is-loading'); });
        syncActions();
      });
    }

    /* ---- add to cart ---- */
    var addBtns = $$('[data-sgc-add]');
    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var built = buildItems();
        if (built.missing || !built.items.length) { setMsg(configurationError(), true); return; }
        setMsg('');
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        withLoading(addBtns, function () {
          return post(addUrl, { items: built.items, sections: sectionsToRender(), sections_url: window.location.pathname })
            .then(function (r) {
              if (!r.ok) { setMsg((r.data && (r.data.description || r.data.message)) || 'Could not add to cart.', true); return; }
              setMsg('Added to your cart.');
              openDrawer(r.data.sections);
              updateCartIcon(r.data.sections);
              if (window.PubSub && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                window.PubSub.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sgc', cartData: r.data });
              }
            })
            .catch(function (err) { console.error('[sgc] add failed', err); setMsg('Network error. Please try again.', true); });
        });
      });
    });

    /* ---- checkout now ---- */
    var checkoutBtns = $$('[data-sgc-checkout]');
    checkoutBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var built = buildItems();
        if (built.missing || !built.items.length) { setMsg(configurationError(), true); return; }
        setMsg('');
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        withLoading(checkoutBtns, function () {
          return post(addUrl, { items: built.items })
            .then(function (r) {
              if (!r.ok) { setMsg((r.data && (r.data.description || r.data.message)) || 'Could not start checkout.', true); return; }
              window.location.href = '/checkout';
            })
            .catch(function (err) { console.error('[sgc] checkout failed', err); setMsg('Network error. Please try again.', true); });
        });
      });
    });

    /* ---- mobile sticky bar visibility ---- */
    var bar = $('[data-sgc-bar]'), summary = $('.sgc-summary');
    if (bar && summary && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('show', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40% 0px' }).observe(summary);
    }

    /* init */
    paintSizeOptionPrices();
    paintSize(); paintPlan(); paintAddons(); paintMedia(); render();
  }

  function boot() { document.querySelectorAll('[data-sgc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
